import React from 'react';
import PropTypes from 'prop-types';

import VistaprintImageUtil from 'utils/VistaprintImageUtil';
import ImageThumbnail from 'components/media/ImageThumbnail';

export default function DocumentPageThumbnail(props) {
    const {
        templateId,
        altDocId,
        pageNumber,
        shadow,
        width, // desired width of the container
        height, // desired height of the container
        maxWidth,
        maxHeight,
        imageWidthPixels, // width in pixels of the document page
        imageHeightPixels, // height in pixels of the document page
        zoomable = false,
        zoomFactor = 1,
        ...restProps
    } = props;

    const src = templateId 
        ? VistaprintImageUtil.getTemplatePreviewURLByTemplateDescriptor(templateId, {
            height: zoomable ? zoomFactor * imageHeightPixels : imageHeightPixels,
            width: zoomable ? zoomFactor * imageWidthPixels : imageWidthPixels,
        })
        : VistaprintImageUtil.getDocumentPreviewURL(altDocId, pageNumber, {
            height: zoomable ? zoomFactor * imageHeightPixels : imageHeightPixels,
            width: zoomable ? zoomFactor * imageWidthPixels : imageWidthPixels,
        });

    const altText = templateId 
        ? `Vistaprint template ${templateId}`
        : `Vistaprint document page ${pageNumber}`;

    return (
        <ImageThumbnail
            showBorder={false}
            checkeredBackground={true}
            src={src}
            alt={altText}
            width={width}
            height={height}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
            style={{
                boxShadow: shadow ? 'rgba(0, 0, 0, 0.3) 0px 5px 18px' : ''
            }}
            {...restProps}
        />
    );
}

DocumentPageThumbnail.propTypes = {
    altDocId: PropTypes.string,
    docId: PropTypes.number,
    pageNumber: PropTypes.number.isRequired,
    shadow: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    imageWidthPixels: PropTypes.number.isRequired,
    imageHeightPixels: PropTypes.number.isRequired,
    style: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/DocumentPageThumbnail.js